import React from "react"
import { useStaticQuery, graphql } from "gatsby"

let sections = []

const dataCollectionQuery = graphql`
query allWpMedia {
    allWpMediaItem(
        filter: {
            mediaType: {eq: "image"}
        }
    ) {
        edges {
            node {
                sourceUrl
                localFile {
                    publicURL
                }
                height
                width
            }
        }
    }
    allWpPost {
        edges {
            node {
                uri
            }
        }
    }
    allWpPage {
        edges {
            node {
                uri
            }
        }
    }
}`

export const CapitalizeLastTwo = str => {
    let lastTwo = str.slice(-2)
    let rest = str.slice(0, -2)
    return rest + lastTwo.toUpperCase()
}

export const lookThroughParents = (obj) => {
    let result = false
    if ( !obj.parent ) return false
    if ( !obj.parent.attribs ) return false

    sections.forEach(section => {
        if ( obj.parent.attribs['data-id'] === section ) {
            result = true
            return false
        }
    });
    
    if ( result ) return result
    
    return lookThroughParents(obj.parent)
}

export const PrepMedia = node => {
    const { allWpPage, allWpPost } = useStaticQuery(dataCollectionQuery)
    let allWpUriArray = []
    
    allWpPage.edges.forEach(page => { allWpUriArray.push(page.node.uri) })
    allWpPost.edges.forEach(post => { allWpUriArray.push(post.node.uri) })

    // Temporarily disable search START
    if ( node.name === 'div' && node.attribs.class && 
        node.attribs.class.includes('search-icon') ) 
            return <></>
    // Temporary disable search END

    if ( node.name === 'img' ) {
        let loadingAttr = ( lookThroughParents(node) ) ?
            'eager' : 'lazy'

        if ( node.attribs && node.attribs.alt === 'hidden-image' )
            return <></>
            
        if ( node.parent && node.parent.parent && node.parent.parent.parent && 
            node.parent.parent.parent.attribs['data-widget_type'] ===
            "theme-site-logo.default" ) loadingAttr = 'eager'
        
        if ( node.attribs.src && 
            !node.attribs.src.includes('data:image')) {
                return <PostImage src={node.attribs.src}
                    loading={loadingAttr}
                    imgWidth={node.attribs.width}
                    imgHeight={node.attribs.height}
                    classNames={node.attribs.class}
                    alt={node.attribs.alt} />
            
        }
    }
    
    if ( node.name === 'a' && node.attribs.href && 
        !node.attribs.href.match(/^(\/#|#)(.*)/) ) {
        
        // let homeUrl = ( node.attribs['data-lang'] !== 'en' ) ? 
        //     '/'+ node.attribs['data-lang'] +'/' : '/'
        
        delete node.attribs['data-lang']

        // if ( !allWpUriArray.includes(node.attribs.href.replace(/#(.*)/, '')) &&
        //     !node.attribs.href.match(/(http:\/\/)|(https:\/\/)|(lp.)/) ) 
        //         node.attribs.href = homeUrl
    }

    // Remove when eKit is discarded START
    if ( node.name === 'i' ) {
        if ( node.attribs.class && node.attribs.class.includes('elementskit-submenu-indicator') )
            node.attribs.class = 'fa fa-solid fa-caret-down'

        // const iconClasses = node.attribs.class
        // const iconClassArray = iconClasses.split(' ')

        // let theIcon = ''
        // let svgData = ''

        // iconClassArray.forEach(iconClass => {
        //     if ( iconClass.match(/^(fa-)(?!(solid|brands))/) ) {
        //         const iconSegments = iconClass.split('-')

        //         iconSegments.forEach((iconSegment, i) => {
        //             theIcon += ( i !== 0 ) ? 
        //                 capitalizeFirstLetter(iconSegment) : iconSegment
        //         })
        //     }
        // })

        // svgData = require('../../static/icons/fa/' + theIcon + '.json')

        // svgData.width = ( typeof svgData.width === undefined ) ?
        //     100 : svgData.width
        // svgData.height = ( typeof svgData.height === undefined ) ?
        //     100 : svgData.height

        // return <svg xmlns="http://www.w3.org/2000/svg" 
        //             width="1em" height="1em"
        //             style={{
        //                 height: '1em',
        //                 position: 'relative',
        //                 margin: '0 .3em',
        //             }}
        //             viewBox={`0 0 ${svgData.width} ${svgData.height}`}>
        //         <path fill="#000" d={svgData.svgPathData} />
        //     </svg>
    }

    if ( node.name === 'button' && 
        node.attribs.class.includes('elementskit-menu-hamburger')) {
            node.attribs['aria-label'] = "Menu toggle"
    }

    // Remove when eKit is discarded END

    // Removal of hreflang START
    if ( node.name === 'a' && node.attribs.hreflang ) {
        node.attribs['data-lang'] = node.attribs.hreflang
        delete node.attribs.hreflang
        delete node.attribs.lang
    }

    if ( node.name === 'a' && node.attribs.href && 
        node.attribs.href.includes('#new_tab')) {
            node.attribs.href = node.attribs.href.replace('#new_tab', '') 
            node.attribs.target = '_blank'
    }

    if ( node.name === 'style' && node.attribs['data-custom'] !== '' ) 
        return <></>

    if ( node.name === 'div' ) {
        // GRM exclusive
        if ( node.attribs.id && 
            node.attribs.id === 'searchform'  ) {
                
            return <></>
        }

        if ( node.attribs.class ) { 
            if ( node.attribs.class.includes('e-n-tabs-content') && 
                node.attribs.role && node.attribs.role === 'tablist' ) {
                    node.children.forEach((child, i) => {
                        child.attribs.role = 'tab'
                    })
            }

            // Swiper START
            if ( node.attribs.class.includes('swiper-container') ) {
                node.children.push({
                    type: 'tag',
                    name: 'link',
                    attribs: {
                        rel: 'stylesheet',
                        href: '/styles/swiper-bundle.min.css'
                    }
                })
        
                node.children.push({
                    type: 'tag',
                    name: 'link',
                    attribs: {
                        rel: 'stylesheet',
                        href: '/styles/swiper.min.css'
                    }
                })
            }
            // Swiper END
        }

        if ( node.attribs['data-gatsby-image-wrapper'] !== undefined ) {
            let loadingAttr = ( lookThroughParents(node) ) ?
                'eager' : 'lazy'
            
            if ( node.children[2].attribs['data-src'] ) {
                let src = node.children[2].attribs['data-src']
                    .replace(/&a=(.*)/, '')

                return <PostImage src={ src }
                    imgWidth={node.children[2].attribs.width}
                    imgHeight={node.children[2].attribs.height}
                    loading={loadingAttr}
                    classNames={node.children[2].attribs.class}
                    alt={node.children[2].attribs.alt} />

            }
        }

        if ( node.attribs['data-elementor-type'] &&
            node.attribs['data-elementor-type'] === 'wp-page' ) {
             
            node.children.forEach((child, i) => {
                if ( i < 2 ) 
                    sections.push(child.attribs['data-id'])
            })
        }
    }

    if ( node.name === 'link' && node.attribs.href.includes('wp-content') ) 
        return <></>

    if (node.name === 'script' &&
        node.attribs['data-wp-inline-image-hydration'] !== undefined) {

        let wpUrls = [...new Set(
            node.children[0].data.match(/https%3A%2F%2Fgrmlang(.*?)&/g)
        )]

        if ( wpUrls[0] !== undefined)  {
            wpUrls.forEach(url => {
                url = url.replace('&', '')
                let newUrl = GetLocalImageFromUrl(decodeURIComponent(url))

                if ( newUrl !== false ) {
                    let newJson = node.children[0].data
                    
                    newJson = newJson.replaceAll(/\/_gatsby\/(.*?)?u=/g, '')
                    newJson = newJson.replaceAll(/&a=(.*?)\s/g, ' ')
                    newJson = newJson.replaceAll(url, newUrl)

                    node.children[0].data = newJson
                }
            })
        }
    }

    if ( node.name === 'section' ) {
        if ( node.attribs['data-settings'] !== undefined &&
            node.attribs['data-bg'] !== undefined ) {
            
            let bgImageAttrib = node.attribs['data-bg']

            if ( bgImageAttrib.includes('wp-content') ) {
                bgImageAttrib = FindLocalImg(bgImageAttrib)

                if ( bgImageAttrib === '' )
                    delete node.attribs['data-bg']
            }

            if ( bgImageAttrib ) {
                let childImg = {
                    attribs: {
                        alt: 'hidden-image',
                        src: bgImageAttrib,
                    },
                    name: 'img',
                    type: 'tag',
                    width: 0
                }

                node.children.push(childImg)
            
                return node
            }
        }
    }

    if ( node.name === 'iframe' ) {
        if ( !node.attribs.loading )
            node.attribs.loading = 'lazy'
        
        if ( node.attribs.src ) {
            let srcUrl = node.attribs.src
            let currentPageURL = node.attribs['data-page-slug']
            let glue = ( srcUrl.includes('?') ) ? 
                "&" : "?"
            
            if ( srcUrl && srcUrl.includes('info.grmdocumentmanagement.com') )
                node.attribs.src = srcUrl + glue + "path="+ currentPageURL
        }
    }
}

export const capitalizeFirstLetter = ((string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
})

export const FindLocalImg = (src) => {
    const { allWpMediaItem } = useStaticQuery(dataCollectionQuery)
    const originalSource = decodeURIComponent(
        src.replace(/-(\d+.)x(\d+)./,'.')
    )
    let localImage = ''

    allWpMediaItem.edges.forEach(({ node }) => {
        if ( node.sourceUrl === originalSource )
            localImage = node.localFile.publicURL
    })

    return localImage
}

export const PostImage = ({ src, alt, classNames = '', 
        styleStr = '', loading = 'lazy', imgWidth, imgHeight}) => {
    const { allWpMediaItem } = useStaticQuery(dataCollectionQuery)
    const srcMod = src.replace(/(.*)?u=(.*?)/g, '$2')

    if ( srcMod.includes('wp-') ) {
        const originalSource = decodeURIComponent(
            srcMod.replace(/-(\d+.)x(\d+)./,'.')
        )
        const originalSourceScaled = decodeURIComponent(
            srcMod.replace(/-(\d+.)x(\d+)./,'-scaled.')
        )

        let localImage = allWpMediaItem.edges.find(({ node }) => 
            node.sourceUrl === originalSource ) || 
            allWpMediaItem.edges.find(({ node }) => 
                node.sourceUrl === originalSourceScaled )

        if ( localImage )
            return <img width={localImage.node.width}
                className={classNames}
                height={localImage.node.height}
                src={localImage.node.localFile.publicURL}
                srcSet={encodeURI(localImage.node.localFile.publicURL)}
                alt={alt}
                loading={loading} />

        return <></>
    }

    return <img loading={loading}
        width={imgWidth}
        height={imgHeight}
        className={classNames}
        src={src}
        srcSet={encodeURI(src)}
        alt={alt} />
}

export const GetLocalImageFromUrl = (src) => {
    const { allWpMediaItem } = useStaticQuery(dataCollectionQuery)
    const localImage = allWpMediaItem.edges.find(({ node }) =>
        node.sourceUrl === src)
    let newUrl = ( localImage ) ? 
        localImage.node.localFile.publicURL : false
        
    return newUrl 
}